import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {ReportsView} from "../views/reports";
import {User} from "../bo/user";

export class ReportsFunction extends AppFunction {

    readonly v : View;

    constructor(user: User) {
        super();
        this.v = new ReportsView(user);
    }

    view() {
        return this.v;
    }

    url() {
        return `/reports`;
    }

    isCacheable(): boolean {
        return true;
    }
}
